import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc } from 'firebase/firestore';
import { app, db } from './firebase';

const VAPID_KEY = 'BE-NB_oBYdMHsLAFeIaSeV_dyX8FgYAFkmRDYV1UoPrguj8o1YK2DR9dY9mGSBnwB9H_axpGTGoDQIaUYk0yLIE';
export const requestNotificationPermission = async (uid: string) => {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.warn('Push not supported');
      return;
    }

    const permission = await Notification.requestPermission();
    console.log('Notification permission:', permission);
    if (permission !== 'granted') return;

    // Registrar SW con updateViaCache: 'none' para que el browser
    // siempre compruebe si hay una versión nueva en el servidor
    const registration = await navigator.serviceWorker.register('/sw.js', {
      updateViaCache: 'none',
    });

    // Si hay una versión nueva esperando, activarla de inmediato
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }

    // Esperar a que el SW esté completamente activo
    await navigator.serviceWorker.ready;
    console.log('SW registered:', registration);

    const messaging = getMessaging(app);
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    console.log('FCM Token:', token);

    if (token) {
      await updateDoc(doc(db, 'users', uid), { fcmToken: token });
      console.log('Token saved to Firestore ✓');
    } else {
      console.warn('No token received');
    }
  } catch (e) {
    console.error('FCM error:', e);
  }
};

export const onForegroundMessage = (callback: (payload: any) => void) => {
  try {
    const messaging = getMessaging(app);
    return onMessage(messaging, callback);
  } catch (e) {
    console.error('onMessage error:', e);
    return () => {};
  }
};